import { addProductToWishlist, whenWishlistLoaded, isProductInWishlist, removeProductFromWishlist } from '../services/wishlist.service';
import '../../styles/web-components/wishlist-button.scss';
const ADDED = 'added';
const NOT_ADDED = 'not-added';
const template = `
  <button type="button" class="product__add-wishlist-button js-add-wishlist-product" data-status="not-added">
    <span class="product__add-wishlist-icon" aria-hidden="true"></span>
    <span class="ADA__visually-hidden">Add to Wishlist</span>
  </button>
`;
class WishlistButton extends HTMLElement {
    constructor() {
        super();
    }
    productId;
    button;
    connectedCallback() {
        this.innerHTML = template;
        this.productId = +this.getAttribute("product-id");
        this.button = this.querySelector('.js-add-wishlist-product');
        this.button.addEventListener('click', () => this.handleClick());
        whenWishlistLoaded().then(() => isProductInWishlist(this.productId)).then((isInWishlist) => {
            this.setWishlistStatus(isInWishlist);
        });
    }
    handleClick() {
        if (this.button.dataset.status === NOT_ADDED) {
            const payload = {
                epi: +this.getAttribute("variant-id"),
                empi: this.productId,
                du: this.getAttribute("product-url")
            };
            addProductToWishlist(payload).then(() => this.setWishlistStatus(true));
        }
        else if (this.button.dataset.status === ADDED) {
            removeProductFromWishlist(this.productId).then(() => this.setWishlistStatus(false));
        }
    }
    setWishlistStatus(added) {
        const status = added ? ADDED : NOT_ADDED;
        this.button.dataset.status = status;
        this.button.setAttribute('aria-pressed', added ? "true" : "false");
    }
}
if (!window.customElements.get("wishlist-button")) {
    customElements.define("wishlist-button", WishlistButton);
}
